(() => {
  const CONFIG = {
    duration: 7000,
    leafCount: 22,
    maxStartDelay: 1800
  };

  const LEAVES = ['🍂', '🍁', '🍂', '🍁', '🍃'];

  function showGoldenLeafReward() {
    if (document.querySelector('.ceel-golden-reward')) return;

    const overlay = document.createElement('div');
    overlay.className = 'ceel-golden-reward';

    overlay.innerHTML = `
      <div class="ceel-golden-card">
        <button class="ceel-golden-close" aria-label="Затвори">×</button>

        <div class="ceel-golden-icon">🍁</div>

        <div class="ceel-golden-small">
          ХВАНА ЗЛАТНОТО ЛИСТО!
        </div>

        <div class="ceel-golden-title">
          ПЕЧЕЛИШ -5%
        </div>

        <div class="ceel-golden-text">
          Използвай кода при завършване на поръчката:
        </div>

        <div class="ceel-golden-code">
          <span>GOLDEN5</span>
          <button class="ceel-copy-code">КОПИРАЙ</button>
        </div>

        <div class="ceel-copy-success">
          Кодът е копиран ✓
        </div>
      </div>
    `;

    Object.assign(overlay.style, {
      position: 'fixed',
      inset: '0',
      zIndex: '1000001',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
      background: 'rgba(30, 15, 5, 0.38)',
      backdropFilter: 'blur(3px)',
      opacity: '0',
      transition: 'opacity 0.25s ease'
    });

    document.body.appendChild(overlay);

    const card = overlay.querySelector('.ceel-golden-card');

    Object.assign(card.style, {
      position: 'relative',
      width: 'min(420px, 92vw)',
      padding: '34px 28px 30px',
      boxSizing: 'border-box',
      textAlign: 'center',
      borderRadius: '22px',
      background:
        'linear-gradient(145deg, #fffaf0 0%, #f5dfac 50%, #d6a84d 100%)',
      border: '1px solid rgba(117, 73, 20, 0.25)',
      boxShadow: '0 24px 70px rgba(49, 27, 5, 0.35)',
      color: '#3d260f',
      transform: 'scale(0.88)',
      transition: 'transform 0.3s ease'
    });

    const close = overlay.querySelector('.ceel-golden-close');

    Object.assign(close.style, {
      position: 'absolute',
      right: '15px',
      top: '10px',
      border: '0',
      background: 'transparent',
      color: '#5b3a17',
      fontSize: '30px',
      cursor: 'pointer'
    });

    const icon = overlay.querySelector('.ceel-golden-icon');

    Object.assign(icon.style, {
      fontSize: '54px',
      marginBottom: '5px'
    });

    const small = overlay.querySelector('.ceel-golden-small');

    Object.assign(small.style, {
      fontSize: '13px',
      letterSpacing: '2px',
      fontWeight: '700',
      marginBottom: '7px'
    });

    const title = overlay.querySelector('.ceel-golden-title');

    Object.assign(title.style, {
      fontSize: '34px',
      lineHeight: '1.1',
      fontWeight: '800',
      marginBottom: '13px'
    });

    const text = overlay.querySelector('.ceel-golden-text');

    Object.assign(text.style, {
      fontSize: '15px',
      lineHeight: '1.5',
      marginBottom: '18px'
    });

    const code = overlay.querySelector('.ceel-golden-code');

    Object.assign(code.style, {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '12px',
      padding: '10px 10px 10px 18px',
      background: 'rgba(255,255,255,0.72)',
      border: '1px dashed #8c5b1d',
      borderRadius: '12px',
      fontSize: '19px',
      fontWeight: '800',
      letterSpacing: '1.5px'
    });

    const copyButton = overlay.querySelector('.ceel-copy-code');

    Object.assign(copyButton.style, {
      border: '0',
      borderRadius: '8px',
      padding: '10px 14px',
      background: '#4c3013',
      color: '#fff',
      fontWeight: '700',
      cursor: 'pointer'
    });

    const success = overlay.querySelector('.ceel-copy-success');

    Object.assign(success.style, {
      display: 'none',
      marginTop: '12px',
      fontSize: '13px',
      fontWeight: '700'
    });

    requestAnimationFrame(() => {
      overlay.style.opacity = '1';
      card.style.transform = 'scale(1)';
    });

    function closeReward() {
      overlay.style.opacity = '0';
      card.style.transform = 'scale(0.92)';

      setTimeout(() => {
        overlay.remove();
      }, 250);
    }

    close.addEventListener('click', closeReward);

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closeReward();
    });

    copyButton.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText('GOLDEN5');
      } catch (error) {
        const textarea = document.createElement('textarea');
        textarea.value = 'GOLDEN5';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
      }

      copyButton.textContent = 'КОПИРАН ✓';
      success.style.display = 'block';
    });
  }

  function startAutumnLeaves() {
    if (document.querySelector('.ceel-autumn-leaves')) return;

    if (
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) return;

    const container = document.createElement('div');
    container.className = 'ceel-autumn-leaves';
    container.setAttribute('aria-hidden', 'true');

    Object.assign(container.style, {
      position: 'fixed',
      inset: '0',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      pointerEvents: 'none',
      zIndex: '999999',
      contain: 'strict'
    });

    document.body.appendChild(container);

    for (let i = 0; i < CONFIG.leafCount; i++) {
      const leaf = document.createElement('span');

      const goldenLeafAlreadyCaught =
  localStorage.getItem('ceelGoldenLeafCaught') === 'true';

const isGolden = i === 7 && !goldenLeafAlreadyCaught;

      leaf.className = isGolden
        ? 'ceel-autumn-leaf ceel-golden-leaf'
        : 'ceel-autumn-leaf';

      leaf.textContent = isGolden
        ? '🍁'
        : LEAVES[Math.floor(Math.random() * LEAVES.length)];

      const startX = isGolden
        ? 25 + Math.random() * 50
        : Math.random() * 100;

      const size = isGolden
        ? 48
        : 18 + Math.random() * 24;

      const fallDuration = isGolden
        ? 6200
        : 3500 + Math.random() * 1800;

      const delay = isGolden
        ? 500
        : Math.random() * CONFIG.maxStartDelay;

      const drift1 = -50 + Math.random() * 100;
      const drift2 = -90 + Math.random() * 180;

      const rotation1 = -100 + Math.random() * 200;
      const rotation2 = 360 + Math.random() * 500;

      Object.assign(leaf.style, {
        position: 'absolute',
        left: `${startX}vw`,
        top: '-70px',
        fontSize: `${size}px`,
        lineHeight: '1',
        opacity: '0',
        willChange: 'transform, opacity',
        userSelect: 'none',
        cursor: isGolden ? 'pointer' : 'default',
        pointerEvents: isGolden ? 'auto' : 'none',
        zIndex: isGolden ? '10' : '1'
      });

      if (isGolden) {
  leaf.style.filter =
    'sepia(1) saturate(5) hue-rotate(350deg) brightness(1.25) drop-shadow(0 0 9px rgba(255,190,40,.95)) drop-shadow(0 0 18px rgba(255,150,0,.7))';

  leaf.title = 'Хвани ме 🍁';

  // Малка подсказка върху самото златно листо
  const hint = document.createElement('span');
  hint.textContent = '✨ ХВАНИ МЕ!';

  Object.assign(hint.style, {
    position: 'absolute',
    left: '50%',
    bottom: '100%',
    transform: 'translateX(-50%)',
    marginBottom: '5px',
    padding: '5px 9px',
    borderRadius: '20px',
    background: 'rgba(255, 248, 220, 0.96)',
    border: '1px solid rgba(184, 132, 28, 0.65)',
    color: '#5a3910',
    fontSize: '11px',
    fontWeight: '800',
    letterSpacing: '0.7px',
    lineHeight: '1',
    whiteSpace: 'nowrap',
    boxShadow: '0 3px 12px rgba(92, 55, 8, 0.22)',
    pointerEvents: 'none',
    opacity: '0',
    transition: 'opacity 0.35s ease'
  });

  leaf.appendChild(hint);

  // Появява се малко след листото
  setTimeout(() => {
    if (hint.isConnected) {
      hint.style.opacity = '1';
    }
  }, 1000);

  leaf.addEventListener('click', () => {
    localStorage.setItem('ceelGoldenLeafCaught', 'true');
    showGoldenLeafReward();
    leaf.remove();
  });
}

      container.appendChild(leaf);

      leaf.animate(
        [
          {
            transform:
              'translate3d(0, -70px, 0) rotate(0deg)',
            opacity: 0
          },
          {
            transform:
              `translate3d(${drift1}px, 20vh, 0) rotate(${rotation1}deg)`,
            opacity: 1,
            offset: 0.18
          },
          {
            transform:
              `translate3d(${drift2}px, 60vh, 0) rotate(${rotation2 / 2}deg)`,
            opacity: 1,
            offset: 0.65
          },
          {
            transform:
              `translate3d(${drift1}px, 115vh, 0) rotate(${rotation2}deg)`,
            opacity: 0
          }
        ],
        {
          duration: fallDuration,
          delay,
          easing: 'linear',
          fill: 'forwards'
        }
      );
    }

    setTimeout(() => {
      container.remove();
    }, CONFIG.duration);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startAutumnLeaves,
      { once: true }
    );
  } else {
    startAutumnLeaves();
  }
})();